// 站点图片资源统一走 OSS，本地不再打包图片
// 目录结构与原 src/assets/ 一一对应，例如 oss("Platform/p2.png")
const OSS_BASE =
  "https://fish-qiyu-dev.oss-cn-guangzhou.aliyuncs.com/website/assets/";

// encodeURI 处理中文文件名等特殊字符
export const oss = (path: string) => OSS_BASE + encodeURI(path);

export default oss;
